import React from 'react';
import FAQ from '@jobseeker/lotus/components/FAQ';
import {Box} from '@mui/material';
import {useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';

const FAQSection = () => {
  const {
    timelines: {
      config: {faqData},
    },
  } = useSelector((state: AppState) => state.competition);
  return (
    <>
      <Box id="faqs">
        <FAQ faqData={faqData} />
      </Box>
    </>
  );
};

export default FAQSection;
